module.exports = __webpack_public_path__ + "fonts/Ubuntu-MediumItalic.b4066c9.ttf";